<template>
	<!-- 头部整体盒子 -->
	<div :id=" isVisable ? 'header':'header2'">
		<!-- 电脑导航 -->
		<div class="header-nav container hidden-xs">
			<!-- 导航logo -->
			<div class="header-nav-logo">
				<img src="@/assets/img/logo_black.png">
			</div>
			<!-- 联系方式 -->
			<div class="phone">
				<img src="@/assets/img/phone_logo.png" alt="" />
				<div class="phone_num">
					400-091-8787
				</div>
			</div>
			<!-- 导航内容 -->
			<ul class="header-nav-wrapper">
				<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
					@click="navClick(index,item.name)">
					<router-link :to="item.path">
						{{item.name}}
						<span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
						<i class="underline"></i>
					</router-link>
					<dl v-if="item.children.length>0">
						<dt v-for="(i,n) in item.children" :key="n">
							<router-link :to="i.path">{{i.name}}</router-link>
						</dt>
					</dl>
				</li>
			</ul>
		</div>

		<!-- 手机导航 -->
		<div class="header-nav-m container-fuild visible-xs">
			<div class="header-nav-m-logo">
				<img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
			</div>
			<!-- 导航栏 -->
			<div class="header-nav-m-menu text-center">
				<img v-if="isVisable" src="@/assets/img/phone_nav2.png" alt="" />
				<img v-else src="@/assets/img/phone_nav.png" alt="" />
				<div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
					<span :class="menuClass"></span>
				</div>
				<!-- 导航内容 -->
				<ul id="menu" class="header-nav-m-wrapper collapse">
					<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
						@click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
						<router-link :to="item.path">
							{{item.name}}
							<i class="underline"></i>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Header",
		data() {
			return {
				isVisable: true,
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				menuName: "首页",
				menuClass: "glyphicon glyphicon-menu-down",
				navList: [{
						name: "首页",
						path: "/",
						children: []
					},
					{
						name: "产品业务",
						path: "/phone",
						children: []
					},
					{
						name: "项目中心",
						path: "/watch",
						children: []
					},
					{
						name: "企业介绍",
						path: "/companyIntroduction",
						children: []
					}
				]
			};
		},
		created() {
			window.addEventListener('scroll', this.windowscrollListener)
		},
		deactivated() {
			window.removeEventListener('scroll', this.windowscrollListener)
		},
		methods: {
			//监听窗口滚动
			windowscrollListener() {
				//获取操作元素最顶端到页面顶端的垂直距离
				const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				if (scrollTop == 0) {
					this.isVisable = true;
				} else {
					this.isVisable = false;

				}
			},
			navClick(index, name) {
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
			},
			menuClick() {
				if (this.menuClass == "glyphicon glyphicon-menu-down") {
					this.menuClass = "glyphicon glyphicon-menu-up";
				} else {
					this.menuClass = "glyphicon glyphicon-menu-down";
				}
			}
		}
	};
</script>
<style scoped>
	/* 顶部 */
	#header {
		background: none;
		transition: all ease 0.6s;
		position: absolute;
		top: 0;
		width: 100%;
	}

	#header2 {
		background: #fff;
		transition: all ease 0.6s;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 1;
	}

	#header .header-top {
		height: 50px;
		color: #fff;
		font-size: 12px;
		line-height: 50px;
		background: #474747;
	}

	/* 顶部的图标 */
	#header .header-top span {
		margin: 0 8px;
	}

	/* 导航栏 */
	#header .header-nav {
		height: 110px;
	}

	/* 导航栏 */
	#header2 .header-nav {
		height: 110px;
	}

	/* 导航栏logo */
	#header .header-nav .header-nav-logo {
		width: 100px;
		height: 100%;
		float: left;
		position: relative;

	}

	/* 导航栏logo */
	#header2 .header-nav .header-nav-logo {
		width: 100px;
		height: 100%;
		float: left;
		position: relative;
	}

	/* 导航栏logo图片 */
	#header .header-nav .phone {
		float: right;
		position: relative;
		display: flex;
		justify-content: space-evenly;
		width: 147px;
		height: 40px;
		border-radius: 4px 4px 4px 4px;
		background: linear-gradient(90deg, #FDA10F 0%, #FA7726 100%);
		line-height: 40px;
		margin-left: 50px;
		margin-top: 35px;
	}

	/* 导航栏logo图片 */
	#header2 .header-nav .phone {
		float: right;
		position: relative;
		display: flex;
		justify-content: space-evenly;
		width: 147px;
		height: 40px;
		border-radius: 4px 4px 4px 4px;
		background: linear-gradient(90deg, #FDA10F 0%, #FA7726 100%);
		line-height: 40px;
		margin-left: 50px;
		margin-top: 35px;
	}

	.phone_num {
		font-size: 14px;
		color: #FFFFFF;
	}

	/* 导航栏logo图片 */
	#header .header-nav .phone img {
		width: 16px;
		height: 16px;
		margin-top: 10px;
	}

	/* 导航栏logo图片 */
	#header2 .header-nav .phone img {
		width: 16px;
		height: 16px;
		margin-top: 10px;
	}


	/* 导航栏logo图片 */
	.header-nav .header-nav-logo img {
		width: 90px;
		height: 50px;
		border-radius: 15px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}


	/* 导航栏 导航容器 */
	.header-nav-fixed .header-nav-wrapper {
		line-height: 50px;
	}

	.header-nav .header-nav-wrapper {
		line-height: 110px;
		float: right;
		margin: 0;
		max-width: 800px;
	}

	/* 导航栏 每个导航 */
	.header-nav .header-nav-wrapper>li {
		float: left;
		margin: 0 40px;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接 */
	.header-nav .header-nav-wrapper>li>a {
		color: #fff;
		font-size: 15px;
		padding: 15px 0;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接 */
	#header2 .header-nav .header-nav-wrapper>li>a {
		color: #666666;
		font-size: 15px;
		padding: 15px 0;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	.header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 0;
		height: 2px;
		opacity: 0;
		transition: all 0.6s ease;
		/* background-color: #FF791F; */
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	.header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	.header-nav .header-nav-wrapper>li>a:hover {
		color: #FF791F;
		text-decoration: none;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	.header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 1;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	.header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(180deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	.header-nav .header-nav-wrapper>li.active>a {
		color: #FF791F;
		text-decoration: none;
		/* border-bottom: 2px solid #FF791F; */
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header2 .header-nav .header-nav-wrapper>li.active>a {
		color: #FF791F;
		text-decoration: none;
		/* border-bottom: 2px solid #FF791F; */
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		width: 168px;
		top: 80%;
		left: 0;
		z-index: 999999;
		box-shadow: 0 0 3px 1px #ccc;
		background: #fff;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>dt {
		width: 100%;
		padding: 10px;
		border-bottom: 1px solid #ccc;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
		text-decoration: none;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: block;
	}

	#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
		cursor: pointer;
		background: #ccc;
	}

	.glyphicon {
		display: none;
	}



	@media screen and (max-width: 997px) {
		#header {
			width: 100%;
			margin: 0px auto;
			padding: 0;
		}

		#header2 {
			width: 100%;
			margin: 0px auto;
			padding: 20px;
		}


		.header-nav {
			width: 761px;
		}

		#header .header-nav-m {
			/* position: relative; */
		}

		/* 导航栏logo容器 */
		#header .header-nav-m .header-nav-m-logo {
			height: 80px;
			position: relative;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-m-logo img {
			width: 54px;
			height: 30px;
			/* position: absolute; */
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
		}

		.header-nav-m-menu-wrapper {
			width: 20px;
			height: 20px;
		}

		.center-block {
			width: 54px;
			height: 30px;
		}

		.header-nav-m-menu img {
			width: 20px;
			height: 20px;
		}

		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #fff;
			height: 50px;
			font-size: 20px;
			line-height: 50px;
			/* background: #474747; */
			/* position: absolute; */
		}

		#header .header-nav-m .header-nav-m-menu img {
			width: 20px;
			height: 20px;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			position: absolute;
			top: 33%;
			right: 20px;
			margin-top: -20px;
			width: 20px;
			height: 20px;
			color: #fff;
			z-index: 999999;
			font-size: 12px;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 75px;
			left: 0;
			width: 100%;
			background: #474747;
			z-index: 9999999;
		}

		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #ccc;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}

		/* 导航栏 */
		#header2 .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 75px;
			left: 0;
			width: 100%;
			background: #474747;
			z-index: 9999999;
		}

		/* 导航栏 每个导航 */
		#header2 .header-nav-m .header-nav-m-wrapper>li {
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #ccc;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header2 .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}

		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 10px;
		}
	}

	@media screen and (max-width: 768px) {
		#header {
			padding: 20px;
			z-index: 1;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue